import React from "react";
import {
  Card,
  CardHeader,
  ListGroup,
  ListGroupItem,
  Row,
  Col,
  Form,
  DatePicker,
  FormInput,
  FormSelect,
  FormTextarea,
  Button,
} from "shards-react";
import BootstrapSwitchButton from "bootstrap-switch-button-react";
import Modal from "react-bootstrap/Modal";
import Accordion from "react-bootstrap/Accordion";
import { TiDeleteOutline } from "react-icons/ti";
import ProjectDataService from "../../services/project.service";
import { FcPlus } from "react-icons/fc";
import { ToastContainer, toast } from "react-toastify";
import { actions as AppActions } from "../../_stores/app.store";
import nav_store, { types as nav_types, actions as nav_actions } from "../../_stores/sidenav.store";

const productApiKeys = [
  "VER_VENDORID",
  "RETAILER_ID",
  "DATA_TYPE",
  "COMP_CODE",
  "COMP_NAME",
  "SALT_NAME",
  "DRUG_TYPE",
  "PROD_CODE",
  "BAR_CODE",
  "PROD_NAME",
  "PACK_SIZE",
  "CONVERSION",
  "UOM",
  "PUR_RATE",
  "MRP",
  "HSNCODE",
  "GST",
  "REMARK",
];
const sasApiKeys = [
  "RECORD_TYPE",
  "VER_VENDORID",
  "RETAILER_ID",
  "PERIOD_START_DATE",
  "PERIOD_END_DATE",
  "CREATED_DATE",
  "CREATED_TIME",
  "PROD_CODE",
  "BAR_CODE",
  "COMP_NAME",
  "PROD_NAME",
  "OPENING_STOCK",
  "GOODS_RECEIVED",
  "GOODS_RECEIVED_FREE",
  "SALES_RETURN",
  "SALES_RETURN_FREE",
  "PURCHASE_RETURN",
  "PURCHASE_RETURN_FREE",
  "SALES_QTY",
  "SALES_FREE_QTY",
  "ADJUSTMENTS",
  "CLOSING_STOCK",
  "CONVERSION",
  "UOM",
  "PUR_RATE",
  "MRP",
  "EXPIRED",
  "EXP_UPTO_90",
  "Remark",
];

class CreateProjectSuperAdmin extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      projectName: "",
      databaseName: "",
      databaseType: "",
      isDataDatabase: false,
      isDataApi: false,
      isApiAuthenticated: false,
      loginInputData: "",
      apiURL: "",
      authHeaderData: "",
      showModal: false,
      dbHostURL: "",
      dbUserName: "",
      dbPassword: "",
      dbName: "",
      dbTableName: "",
      isRequired: true,
      isPrimaryKey: true,
      apiKey: "",
      apiKeyArray: [],
      masterKeyFieldSubmit: false,
      masterKeyFieldName: { value: "", isValid: false },
      masterKeyDataType: { value: "", isValid: false },
      sasFieldSubmit: false,
      sasFieldName: { value: "", isValid: false },
      sasDataType: { value: "", isValid: false },
      masterFieldKeys: [],
      sasFieldKeys: [],
      masterKeyName: "",
      masterFiles: [],
      hasAssociatedTable: false,
      associatedTableName: "",
      asscFieldKeys: [],
      asscKeyFieldSubmit: false,
      asscKeyFieldName: { value: "", isValid: false },
      asscKeyDataType: { value: "", isValid: false },
      isAsscRequired: true,
      isAsscPrimaryKey: true,
    };

    this.onChangeProjectName = this.onChangeProjectName.bind(this);
    this.onChangeDatabaseName = this.onChangeDatabaseName.bind(this);
    this.onChangeDatabaseType = this.onChangeDatabaseType.bind(this);
    this.onChangeIsDataDatabase = this.onChangeIsDataDatabase.bind(this);
    this.onChangeIsDataApi = this.onChangeIsDataApi.bind(this);
    this.onChangeIsApiAuthenticated = this.onChangeIsApiAuthenticated.bind(this);

    this.handleCloseModal = this.handleCloseModal.bind(this);

    this.onChangeMasterKeyName = this.onChangeMasterKeyName.bind(this);
    this.onChangeMasterKeyFieldName = this.onChangeMasterKeyFieldName.bind(this);
    this.onChangeMasterKeyDataType = this.onChangeMasterKeyDataType.bind(this);
    this.onChangeAsscKeyFieldName = this.onChangeAsscKeyFieldName.bind(this);
    this.onChangeAsscKeyDataType = this.onChangeAsscKeyDataType.bind(this);

    this.onSwitchChanged = this.onSwitchChanged.bind(this);
    this.onFieldValueChange = this.onFieldValueChange.bind(this);

    this.onChangeLoginInputData = this.onChangeLoginInputData.bind(this);
    this.onChangeApiURL = this.onChangeApiURL.bind(this);
    this.onChangeAuthHeaderData = this.onChangeAuthHeaderData.bind(this);

    this.openNewFileModal = this.openNewFileModal.bind(this);
    this.handleAddMasterFieldKeys = this.handleAddMasterFieldKeys.bind(this);
    this.handleAddAsscFieldKeys = this.handleAddAsscFieldKeys.bind(this);
    this.createMasterFile = this.createMasterFile.bind(this);
    this.createNewProject = this.createNewProject.bind(this);
  }

  componentDidMount() {}

  onChangeProjectName(e) {
    this.setState({
      projectName: e.target.value,
    });
  }

  onChangeDatabaseName(e) {
    this.setState({
      databaseName: e.target.value,
    });
  }

  onChangeDatabaseType(e) {
    this.setState({
      databaseType: e.target.value,
    });
  }

  onChangeIsDataDatabase(e) {
    this.setState({
      isDataDatabase: e,
    });
  }

  onChangeIsDataApi(e) {
    this.setState({
      isDataApi: e,
    });
  }

  onChangeIsApiAuthenticated(e) {
    this.setState({
      isApiAuthenticated: e,
    });
  }

  onChangeMasterKeyName(e) {
    this.setState({
      masterKeyName: e.target.value,
    });
  }

  onChangeLoginInputData(e) {
    this.setState({
      loginInputData: e.target.value,
    });
  }

  onChangeAuthHeaderData(e) {
    this.setState({
      authHeaderData: e.target.value,
    });
  }

  onChangeApiURL(e) {
    this.setState({
      apiURL: e.target.value,
    });
  }

  onChangeMasterKeyFieldName(e) {
    let isValid = e.target.value ? true : false;
    this.setState({
      masterKeyFieldName: {
        ...this.state.masterKeyFieldName,
        value: e.target.value,
        isValid: isValid,
      },
    });
  }

  onChangeMasterKeyDataType(e) {
    let isValid = e.target.value ? true : false;
    this.setState({
      masterKeyDataType: {
        ...this.state.masterKeyDataType,
        value: e.target.value,
        isValid: isValid,
      },
    });
  }

  onChangeAsscKeyFieldName(e) {
    let isValid = e.target.value ? true : false;
    this.setState({
      asscKeyFieldName: {
        ...this.state.asscKeyFieldName,
        value: e.target.value,
        isValid: isValid,
      },
    });
  }

  onChangeAsscKeyDataType(e) {
    let isValid = e.target.value ? true : false;
    this.setState({
      asscKeyDataType: {
        ...this.state.asscKeyDataType,
        value: e.target.value,
        isValid: isValid,
      },
    });
  }

  onFieldValueChange(e) {
    this.setState({
      [e.target.id]: e.target.value,
    });
  }

  onSwitchChanged(key, value) {
    this.setState({
      [key]: value,
    });
  }

  handleCloseModal() {
    this.setState({
      showModal: false,
      ...this.getMintFileObject(),
    });
  }

  openNewFileModal() {
    this.setState({
      showModal: true,
    });
  }

  createMasterFile() {
    var mstrFileObj = {};
    mstrFileObj.masterKeyName = this.state.masterKeyName;
    mstrFileObj.isApiAuthenticated = this.state.isApiAuthenticated;
    mstrFileObj.loginInputData = this.state.loginInputData;
    mstrFileObj.apiURL = this.state.apiURL;
    mstrFileObj.authHeaderData = this.state.authHeaderData;
    mstrFileObj.dbHostURL = this.state.dbHostURL;
    mstrFileObj.dbUserName = this.state.dbUserName;
    mstrFileObj.dbPassword = this.state.dbPassword;
    mstrFileObj.dbName = this.state.dbName;
    mstrFileObj.dbTableName = this.state.dbTableName;
    mstrFileObj.masterKeyFields = this.state.masterFieldKeys;
    mstrFileObj.hasAssociatedTable = this.state.hasAssociatedTable;
    mstrFileObj.associatedTableName = this.state.associatedTableName;
    mstrFileObj.associatedKeyFields = this.state.asscFieldKeys;

    this.setState({ masterFiles: [...this.state.masterFiles, mstrFileObj] });
    this.handleCloseModal();
  }

  handleAddMasterFieldKeys() {
    this.setState({
      masterKeyFieldSubmit: true,
    });

    if (this.state.masterKeyFieldName.isValid && this.state.masterKeyDataType.isValid) {
      var tableColumn = {};
      tableColumn.fieldName = this.state.masterKeyFieldName.value;
      tableColumn.dataType = this.state.masterKeyDataType.value;
      tableColumn.isRequired = this.state.isRequired;
      tableColumn.isPrimaryKey = this.state.isPrimaryKey;

      this.setState({
        masterFieldKeys: [...this.state.masterFieldKeys, tableColumn],
        masterKeyFieldName: {
          value: "",
          isValid: false,
        },
        masterKeyFieldSubmit: false,
      });
    }
  }

  handleAddAsscFieldKeys() {
    this.setState({
      asscKeyFieldSubmit: true,
    });

    if (this.state.asscKeyFieldName.isValid && this.state.asscKeyDataType.isValid) {
      var tableColumn = {};
      tableColumn.fieldName = this.state.asscKeyFieldName.value;
      tableColumn.dataType = this.state.asscKeyDataType.value;
      tableColumn.isRequired = this.state.isAsscRequired;
      tableColumn.isPrimaryKey = this.state.isAsscPrimaryKey;

      this.setState({
        asscFieldKeys: [...this.state.asscFieldKeys, tableColumn],
        asscKeyFieldName: {
          value: "",
          isValid: false,
        },
        asscKeyFieldSubmit: false,
      });
    }
  }

  deleteMasterKeyFieldName(fieldName) {
    var data = this.state.masterFieldKeys.filter(function (item) {
      return item.fieldName !== fieldName;
    });
    this.setState({
      masterFieldKeys: data,
    });
  }

  deleteAsscKeyFieldName(fieldName) {
    var data = this.state.asscFieldKeys.filter(function (item) {
      return item.fieldName !== fieldName;
    });
    this.setState({
      asscFieldKeys: data,
    });
  }

  getMintFileObject() {
    return {
      masterKeyName: "",
      dbHostURL: "",
      dbUserName: "",
      dbPassword: "",
      dbName: "",
      dbTableName: "",
      isApiAuthenticated: false,
      loginInputData: "",
      apiURL: "",
      authHeaderData: "",
      isRequired: true,
      isPrimaryKey: true,
      masterFieldKeys: [],
      hasAssociatedTable: false,
      associatedTableName: "",
      asscFieldKeys: [],
      isAsscRequired: true,
      isAsscPrimaryKey: true,
    };
  }

  createNewProject() {
    var notify_message = null;
    var data = {
      projectName: this.state.projectName,
      databaseName: this.state.databaseName,
      databaseType: this.state.databaseType,
      dataSendToDatabase: this.state.isDataDatabase,
      dataSendToApi: this.state.isDataApi,
      masterKeys: this.state.masterFiles,
    };

    AppActions.setLoading(true);
    ProjectDataService.create(data).then((response) => {
      AppActions.setLoading(false);
      const notify_message = { type: "", message: "" };
      if (response.data.success) {
        nav_actions.setSideNav(nav_store.dispatch, {});
        // check for success
        notify_message.type = "success";
        notify_message.message = "Project has been created successfully.";
      } else {
        if (response.data.err.sqlMessage) {
          // fields error
          notify_message.type = "error";
          notify_message.message = response.data.err.message;
        } else {
          // mongo error
          notify_message.type = "error";
          notify_message.message = response.data.err.name + " - May be duplicate record";
        }
      }
      this.notify(notify_message.type, notify_message.message);
      this.props.redirectToProjectDetails("/view-projects-superadmin", notify_message);
    });
  }

  //this is for showing notification
  notify(type, message) {
    toast(message, {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: true,
      closeOnClick: true,
      type: type,
    });
  }

  render() {
    const { showModal, masterFieldKeys, asscFieldKeys, masterFiles } = this.state;

    return (
      <div>
        <Card small className="mb-4">
          <CardHeader className="border-bottom">
            <h6 className="m-0">Create New Project</h6>
          </CardHeader>
          <ListGroup flush>
            <ListGroupItem className="">
              <Form>
                <Row form>
                  {/* First Name */}
                  <Col md="12" className="form-group">
                    <Row className="form-group-row">
                      <Col className="form-label" md="4">
                        <label htmlFor="projectName">Project Name</label>
                      </Col>
                      <Col className="form-field" md="8">
                        <FormInput
                          id="projectName"
                          placeholder="Project Name"
                          value={this.state.projectName}
                          onChange={this.onChangeProjectName}
                        />
                      </Col>
                    </Row>

                    <Row className="form-group-row">
                      <Col className="form-label" md="4">
                        <label htmlFor="databaseType">Database Type</label>
                      </Col>
                      <Col className="form-field" md="8">
                        <FormSelect
                            id="databaseType"
                            onChange={this.onChangedatabaseType}
                          >
                            <option value="">Select Database Type</option>
                            <option value="mssql">MSSQL</option>
                          </FormSelect>
                      </Col>
                    </Row>

                    <Row className="form-group-row">
                      <Col className="form-label" md="4">
                        <label htmlFor="databaseName">Database Name</label>
                      </Col>
                      <Col className="form-field" md="8">
                        <FormInput
                          id="databaseName"
                          placeholder="Database Name"
                          value={this.state.databaseName}
                          onChange={this.onChangeDatabaseName}
                        />
                      </Col>
                    </Row>

                    <Row className="form-group-row">
                      <Col className="form-label" md="4">
                        <label htmlFor="isDataDatabase">Data Send To Database</label>
                      </Col>
                      <Col className="form-field" md="8">
                        <BootstrapSwitchButton
                          checked={this.state.isDataDatabase}
                          id="isDataDatabase"
                          onlabel="Yes"
                          offlabel="No"
                          onChange={this.onChangeIsDataDatabase}
                        />
                      </Col>
                    </Row>
                    <Row className="form-group-row">
                      <Col className="form-label" md="4">
                        <label htmlFor="isDataApi">Data Send To API</label>
                      </Col>
                      <Col className="form-field" md="8">
                        <BootstrapSwitchButton
                          checked={this.state.isDataApi}
                          id="isDataApi"
                          onlabel="Yes"
                          offlabel="No"
                          onChange={this.onChangeIsDataApi}
                        />
                      </Col>
                    </Row>

                    <Row className="form-group-row">
                      <Col className="form-field font-bold" md="12">
                        <label htmlFor="">Master Key Files</label>
                        <Button className="ml-3" variant="primary" onClick={this.openNewFileModal}>
                          <FcPlus /> Add Master Key File
                        </Button>
                      </Col>
                    </Row>
                    <Row className="form-group-row">
                      <Accordion>
                        {masterFiles &&
                          masterFiles.map((item, index) => {
                            return (
                              <Accordion.Item eventKey={index + 1} datakey={index + 1} key={index + 1}>
                                <Accordion.Header>{item.masterKeyName}</Accordion.Header>
                                <Accordion.Body>
                                  <Row className="form-group-row">
                                    <Col className="form-label" md="4">
                                      <label htmlFor="">Master Key Name</label>
                                    </Col>
                                    <Col className="form-field flx-items-center" md="8">
                                      {item.masterKeyName}
                                    </Col>
                                  </Row>
                                  <Row className="form-group-row">
                                    <Col className="form-label" md="4">
                                      <label htmlFor="">Database Details</label>
                                    </Col>
                                    <Col className="form-field" md="8">
                                      <Row className="form-group-row">
                                        <Col className="form-label" md="3">
                                          <label htmlFor=""> Host URL</label>
                                        </Col>
                                        <Col className="form-field flx-items-center" md="9">
                                          {item.dbHostURL}
                                        </Col>
                                      </Row>
                                      <Row className="form-group-row">
                                        <Col className="form-label" md="3">
                                          <label htmlFor=""> User Name</label>
                                        </Col>
                                        <Col className="form-field flx-items-center" md="9">
                                          {item.dbUserName}
                                        </Col>
                                      </Row>
                                      <Row className="form-group-row">
                                        <Col className="form-label" md="3">
                                          <label htmlFor=""> Password </label>
                                        </Col>
                                        <Col className="form-field flx-items-center" md="9">
                                          {item.dbPassword}
                                        </Col>
                                      </Row>
                                      <Row className="form-group-row">
                                        <Col className="form-label" md="3">
                                          <label htmlFor=""> Database Name</label>
                                        </Col>
                                        <Col className="form-field flx-items-center" md="9">
                                          {item.dbName}
                                        </Col>
                                      </Row>
                                      <Row className="form-group-row">
                                        <Col className="form-label" md="3">
                                          <label htmlFor=""> Table Name</label>
                                        </Col>
                                        <Col className="form-field flx-items-center" md="9">
                                          {item.dbTableName}
                                        </Col>
                                      </Row>
                                    </Col>
                                  </Row>
                                  <Row className="form-group-row">
                                    <Col className="form-label" md="4">
                                      <label htmlFor="">API Details</label>
                                    </Col>
                                    <Col className="form-field" md="8">
                                      <Row className="form-group-row">
                                        <Col className="form-label" md="3">
                                          <label htmlFor="">Is API Authenticated ?</label>
                                        </Col>
                                        <Col className="form-field flx-items-center" md="9">
                                          {item.isApiAuthenticated ? "YES" : "NO"}
                                        </Col>
                                      </Row>
                                      <Row className="form-group-row">
                                        <Col className="form-label" md="3">
                                          <label htmlFor="">API URL</label>
                                        </Col>
                                        <Col className="form-field flx-items-center" md="9">
                                          {item.apiURL}
                                        </Col>
                                      </Row>
                                      {item.isApiAuthenticated ? (
                                        <>
                                          <Row className="form-group-row">
                                            <Col className="form-label" md="3">
                                              <label htmlFor="">Authentication Header JSON Data</label>
                                            </Col>
                                            <Col className="form-field flx-items-center" md="9">
                                              {item.authHeaderData}
                                            </Col>
                                          </Row>
                                          <Row className="form-group-row">
                                            <Col className="form-label" md="3">
                                              <label htmlFor="">Login Input JSON Data</label>
                                            </Col>
                                            <Col className="form-field flx-items-center" md="9">
                                              {item.loginInputData}
                                            </Col>
                                          </Row>
                                        </>
                                      ) : null}
                                    </Col>
                                  </Row>
                                  <Row className="form-group-row">
                                    <Col className="form-label" md="4">
                                      <label htmlFor="">Master Key Fields</label>
                                    </Col>
                                    <Col className="form-field" md="8">
                                      <Row className="form-group-row border-bottom-button ml-2 mr-2">
                                        <Col className="form-label" md="5">
                                          Master API Field Name
                                        </Col>
                                        <Col className="form-label" md="3">
                                          Data Type
                                        </Col>
                                        <Col className="form-label" md="2">
                                          Required
                                        </Col>
                                        <Col className="form-label" md="2">
                                          Primary
                                        </Col>
                                      </Row>
                                      {item.masterKeyFields &&
                                        item.masterKeyFields.map((mtItem, mtIndex) => {
                                          return (
                                            <Row className="form-group-row border-bottom-button ml-2 mr-2" key={mtIndex + 1}>
                                              <Col className="form-field" md="5">
                                                {mtItem.fieldName}
                                              </Col>
                                              <Col className="form-field" md="3">
                                                {mtItem.dataType}
                                              </Col>
                                              <Col className="form-field" md="2">
                                                {mtItem.isRequired === true ? "Yes" : "No"}
                                              </Col>
                                              <Col className="form-field" md="2">
                                                {mtItem.isPrimaryKey === true ? "Yes" : "No"}
                                              </Col>
                                            </Row>
                                          );
                                        })}
                                    </Col>
                                  </Row>

                                  <Row className="form-group-row">
                                    <Col className="form-label" md="4">
                                      <label htmlFor="">Associated Table</label>
                                    </Col>
                                    <Col className="form-field" md="8">
                                      <Row className="form-group-row">
                                        <Col className="form-label" md="3">
                                          <label htmlFor="">Has Associated Table ?</label>
                                        </Col>
                                        <Col className="form-field flx-items-center" md="9">
                                          {item.hasAssociatedTable ? "YES" : "NO"}
                                        </Col>
                                      </Row>
                                      {this.state.hasAssociatedTable ? (
                                        <>
                                          <Row className="form-group-row customized-01">
                                            <Col className="form-label" md="3">
                                              <label htmlFor="">Associated Table Name</label>
                                            </Col>
                                            <Col className="form-field flx-items-center" md="9">
                                              {item.associatedTableName}
                                            </Col>
                                          </Row>
                                          <Row className="form-group-row border-bottom-button ml-2 mr-2">
                                            <Col className="form-label" md="5">
                                              Table Field Name
                                            </Col>
                                            <Col className="form-label" md="3">
                                              Data Type
                                            </Col>
                                            <Col className="form-label" md="2">
                                              Required
                                            </Col>
                                            <Col className="form-label" md="2">
                                              Primary
                                            </Col>
                                          </Row>
                                          {item.associatedKeyFields &&
                                            item.associatedKeyFields.map((mtItem, mtIndex) => {
                                              return (
                                                <Row
                                                  className="form-group-row border-bottom-button ml-2 mr-2"
                                                  key={mtIndex + 1}
                                                >
                                                  <Col className="form-field" md="5">
                                                    {mtItem.fieldName}
                                                  </Col>
                                                  <Col className="form-field" md="3">
                                                    {mtItem.dataType}
                                                  </Col>
                                                  <Col className="form-field" md="2">
                                                    {mtItem.isRequired === true ? "Yes" : "No"}
                                                  </Col>
                                                  <Col className="form-field" md="2">
                                                    {mtItem.isPrimaryKey === true ? "Yes" : "No"}
                                                  </Col>
                                                </Row>
                                              );
                                            })}
                                        </>
                                      ) : (
                                        <></>
                                      )}
                                    </Col>
                                  </Row>
                                </Accordion.Body>
                              </Accordion.Item>
                            );
                          })}
                      </Accordion>
                    </Row>
                    <Row className="form-group-row">
                      <Col className="form-button" md="4">
                        <Button className="btn btn-primary" theme="accent" onClick={this.createNewProject}>
                          <FcPlus /> Create Project
                        </Button>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </Form>
            </ListGroupItem>
          </ListGroup>
        </Card>
        <ToastContainer />

        <Modal show={showModal} size="lg" className="filePopup" onHide={this.handleCloseModal}>
          <Modal.Header>
            <Modal.Title>Add Master Key File</Modal.Title>
            <div className="closeBtn" onClick={this.handleCloseModal} aria-label="Close">
              <TiDeleteOutline />
            </div>
          </Modal.Header>
          <Modal.Body>
            <Form>
              <Row className="form-group-row">
                <Col className="form-label" md="3">
                  <label htmlFor="masterKeyName"> Master Key Name</label>
                </Col>
                <Col className="form-field" md="9">
                  <FormInput
                    id="masterKeyName"
                    placeholder="Master Key Name"
                    value={this.state.masterKeyName}
                    onChange={this.onChangeMasterKeyName}
                  />
                </Col>
              </Row>
              {this.state.isDataDatabase && (
                <Row className="form-group-row">
                  <Col className="form-label" md="3">
                    <label htmlFor=""> Database Details</label>
                  </Col>
                  <Col className="form-field" md="9">
                    <Row className="form-group-row">
                      <Col className="form-label" md="3">
                        <label htmlFor="dbHostURL"> Host URL</label>
                      </Col>
                      <Col className="form-field" md="9">
                        <FormInput
                          id="dbHostURL"
                          placeholder="Host URL"
                          value={this.state.dbHostURL}
                          onChange={this.onFieldValueChange}
                        />
                      </Col>
                    </Row>
                    <Row className="form-group-row">
                      <Col className="form-label" md="3">
                        <label htmlFor="dbUserName"> User Name</label>
                      </Col>
                      <Col className="form-field" md="9">
                        <FormInput
                          id="dbUserName"
                          placeholder="User Name"
                          value={this.state.dbUserName}
                          onChange={this.onFieldValueChange}
                        />
                      </Col>
                    </Row>
                    <Row className="form-group-row">
                      <Col className="form-label" md="3">
                        <label htmlFor="dbPassword"> Password </label>
                      </Col>
                      <Col className="form-field" md="9">
                        <FormInput
                          id="dbPassword"
                          placeholder="Password"
                          value={this.state.dbPassword}
                          onChange={this.onFieldValueChange}
                        />
                      </Col>
                    </Row>
                    <Row className="form-group-row">
                      <Col className="form-label" md="3">
                        <label htmlFor="dbName"> Database Name</label>
                      </Col>
                      <Col className="form-field" md="9">
                        <FormInput
                          id="dbName"
                          placeholder="Database Name"
                          value={this.state.dbName}
                          onChange={this.onFieldValueChange}
                        />
                      </Col>
                    </Row>
                    <Row className="form-group-row">
                      <Col className="form-label" md="3">
                        <label htmlFor="dbTableName"> Table Name</label>
                      </Col>
                      <Col className="form-field" md="9">
                        <FormInput
                          id="dbTableName"
                          placeholder="Table Name"
                          value={this.state.dbTableName}
                          onChange={this.onFieldValueChange}
                        />
                      </Col>
                    </Row>
                  </Col>
                </Row>
              )}
              {this.state.isDataApi && (
                <Row className="form-group-row">
                  <Col className="form-label" md="3">
                    <label htmlFor=""> API Details</label>
                  </Col>
                  <Col className="form-field" md="9">
                    <Row>
                      <Col className="form-field" md="8">
                        <span className="mr-15">Is API Authenticated ?</span>
                        <BootstrapSwitchButton
                          checked={this.state.isApiAuthenticated}
                          id="isApiAuthenticated"
                          onlabel="Yes"
                          offlabel="No"
                          onChange={this.onChangeIsApiAuthenticated}
                          className="margin-left-20"
                        />
                      </Col>
                    </Row>
                    {this.state.isApiAuthenticated && (
                      <>
                        <Row>
                          <Col className="form-field" md="12">
                            <FormTextarea
                              id="loginInputData"
                              onChange={this.onChangeLoginInputData}
                              rows="6"
                              placeholder="Login Input JSON Data"
                            />
                          </Col>
                        </Row>
                      </>
                    )}

                    <Row>
                      <Col className="form-field" md="12">
                        <FormInput
                          id="apiURL"
                          placeholder="API URL"
                          value={this.state.apiURL}
                          onChange={this.onChangeApiURL}
                        />
                      </Col>
                    </Row>

                    {this.state.isApiAuthenticated && (
                      <>
                        <Row>
                          <Col className="form-field" md="12">
                            <FormTextarea
                              id="authHeaderData"
                              onChange={this.onChangeAuthHeaderData}
                              rows="6"
                              placeholder="Authentication Header JSON Data"
                            />
                          </Col>
                        </Row>
                      </>
                    )}
                  </Col>
                </Row>
              )}

              <Row className="form-group-row border-bottom-button">
                <Col className="form-label" md="3">
                  <label htmlFor="masterTransactionFields"> Master Key Fields</label>
                </Col>
                <Col className="form-field" md="9">
                  <Row>
                    <Col md="7">
                      <Row>
                        <Col className="form-field" md="7">
                          <label htmlFor="masterKeyFieldName">Master Key Field Name</label>
                          <FormInput
                            id="masterKeyFieldName"
                            placeholder="Master Key Field Name"
                            value={this.state.masterKeyFieldName.value}
                            onChange={this.onChangeMasterKeyFieldName}
                            className={
                              this.state.masterKeyFieldSubmit
                                ? this.state.masterKeyFieldName.isValid
                                  ? ""
                                  : "field-error"
                                : ""
                            }
                          />
                        </Col>
                        <Col className="form-field" md="5">
                          <label htmlFor="masterKeyDataType">Data Type</label>
                          <FormSelect
                            id="masterKeyDataType"
                            onChange={this.onChangeMasterKeyDataType}
                            className={
                              this.state.masterKeyFieldSubmit
                                ? this.state.masterKeyDataType.isValid
                                  ? ""
                                  : "field-error"
                                : ""
                            }
                          >
                            <option value="">Select Data Type</option>
                            <option value="Number">Number</option>
                            <option value="String">String</option>
                            <option value="Date">Date</option>
                          </FormSelect>
                        </Col>
                      </Row>
                    </Col>
                    <Col md="5">
                      <Row>
                        <Col className="form-field" md="4">
                          <label htmlFor="isRequired">Required</label>
                          <BootstrapSwitchButton
                            checked={this.state.isRequired}
                            id="isRequired"
                            onlabel="Yes"
                            offlabel="No"
                            onChange={(val) => this.onSwitchChanged("isRequired", val)}
                          />
                        </Col>
                        <Col className="form-field" md="4">
                          <label htmlFor="isPrimaryKey">Primary</label>
                          <BootstrapSwitchButton
                            checked={this.state.isPrimaryKey}
                            id="isPrimaryKey"
                            onlabel="Yes"
                            offlabel="No"
                            onChange={(val) => this.onSwitchChanged("isPrimaryKey", val)}
                          />
                        </Col>
                        <Col className="form-field flx-items-end" md="4">
                          <Button variant="primary" onClick={this.handleAddMasterFieldKeys}>
                            Add {/*<FcPlus size="16" />*/}
                          </Button>
                        </Col>
                      </Row>
                    </Col>
                  </Row>

                  <Row className="form-group-row ml-1 mr-1 border-bottom-button">
                    <Col className="form-label" md="5">
                      <label htmlFor="filedName">Key Field Name</label>
                    </Col>
                    <Col className="form-label" md="2">
                      <label htmlFor="">Data Type</label>
                    </Col>
                    <Col className="form-label" md="2">
                      <label htmlFor="">Required</label>
                    </Col>
                    <Col className="form-label" md="2">
                      <label htmlFor="">Primary</label>
                    </Col>
                    <Col className="form-label" md="1">
                      <label htmlFor="">Action</label>
                    </Col>
                  </Row>
                  {masterFieldKeys &&
                    masterFieldKeys.map((item, index) => {
                      return (
                        <Row className="form-group-row ml-1 mr-1 border-bottom-button" key={index + 1}>
                          <Col className="form-field" md="5">
                            {item.fieldName}
                          </Col>
                          <Col className="form-field" md="2">
                            {item.dataType}
                          </Col>
                          <Col className="form-field" md="2">
                            {item.isRequired === true ? "Yes" : "No"}
                          </Col>
                          <Col className="form-field" md="2">
                            {item.isPrimaryKey === true ? "Yes" : "No"}
                          </Col>
                          <Col className="form-label" md="1">
                            <div
                              className="closeBtn"
                              onClick={this.deleteMasterKeyFieldName.bind(this, item.fieldName)}
                              aria-label="Close"
                            >
                              <TiDeleteOutline />
                            </div>
                          </Col>
                        </Row>
                      );
                    })}
                </Col>
              </Row>

              <Row className="form-group-row border-bottom-button">
                <Col className="form-label" md="3">
                  <label htmlFor="masterTransactionFields"> Associated Table</label>
                </Col>
                <Col className="form-field" md="9">
                  <Row className="mb-3">
                    <Col md="12">
                      <label htmlFor="hasAssociatedTable" className="mr-4">
                        Has Associated Table ?
                      </label>
                      <BootstrapSwitchButton
                        checked={this.state.hasAssociatedTable}
                        id="hasAssociatedTable"
                        onlabel="Yes"
                        offlabel="No"
                        onChange={(val) => this.onSwitchChanged("hasAssociatedTable", val)}
                      />
                    </Col>
                  </Row>

                  {this.state.hasAssociatedTable ? (
                    <>
                      <Row className="mb-3">
                        <Col md="12">
                          <label htmlFor="associatedTableName">Associated Table Name</label>
                          <FormInput
                            id="associatedTableName"
                            placeholder="Associated Table Name"
                            value={this.state.associatedTableName}
                            onChange={this.onFieldValueChange}
                          />
                        </Col>
                      </Row>
                      <Row>
                        <Col md="7">
                          <Row>
                            <Col className="form-field" md="7">
                              <label htmlFor="asscKeyFieldName">Associated Field Name</label>
                              <FormInput
                                id="asscKeyFieldName"
                                placeholder="Associated Field Name"
                                value={this.state.asscKeyFieldName.value}
                                onChange={this.onChangeAsscKeyFieldName}
                                className={
                                  this.state.asscKeyFieldSubmit
                                    ? this.state.asscKeyFieldName.isValid
                                      ? ""
                                      : "field-error"
                                    : ""
                                }
                              />
                            </Col>
                            <Col className="form-field" md="5">
                              <label htmlFor="asscKeyDataType">Data Type</label>
                              <FormSelect
                                id="asscKeyDataType"
                                onChange={this.onChangeAsscKeyDataType}
                                className={
                                  this.state.asscKeyFieldSubmit
                                    ? this.state.asscKeyDataType.isValid
                                      ? ""
                                      : "field-error"
                                    : ""
                                }
                              >
                                <option value="">Select Data Type</option>
                                <option value="Number">Number</option>
                                <option value="String">String</option>
                                <option value="Date">Date</option>
                              </FormSelect>
                            </Col>
                          </Row>
                        </Col>
                        <Col md="5">
                          <Row>
                            <Col className="form-field" md="4">
                              <label htmlFor="isAsscRequired">Required</label>
                              <BootstrapSwitchButton
                                checked={this.state.isAsscRequired}
                                id="isAsscRequired"
                                onlabel="Yes"
                                offlabel="No"
                                onChange={(val) => this.onSwitchChanged("isAsscRequired", val)}
                              />
                            </Col>
                            <Col className="form-field" md="4">
                              <label htmlFor="isAsscPrimaryKey">Primary</label>
                              <BootstrapSwitchButton
                                checked={this.state.isAsscPrimaryKey}
                                id="isAsscPrimaryKey"
                                onlabel="Yes"
                                offlabel="No"
                                onChange={(val) => this.onSwitchChanged("isAsscPrimaryKey", val)}
                              />
                            </Col>
                            <Col className="form-field flx-items-end" md="4">
                              <Button variant="primary" onClick={this.handleAddAsscFieldKeys}>
                                Add {/*<FcPlus size="16" />*/}
                              </Button>
                            </Col>
                          </Row>
                        </Col>
                      </Row>

                      <Row className="form-group-row ml-1 mr-1 border-bottom-button">
                        <Col className="form-label" md="5">
                          <label htmlFor="filedName">Associated Field Name</label>
                        </Col>
                        <Col className="form-label" md="2">
                          <label htmlFor="">Data Type</label>
                        </Col>
                        <Col className="form-label" md="2">
                          <label htmlFor="">Required</label>
                        </Col>
                        <Col className="form-label" md="2">
                          <label htmlFor="">Primary</label>
                        </Col>
                        <Col className="form-label" md="1">
                          <label htmlFor="">Action</label>
                        </Col>
                      </Row>
                      {asscFieldKeys &&
                        asscFieldKeys.map((item, index) => {
                          return (
                            <Row className="form-group-row ml-1 mr-1 border-bottom-button" key={index + 1}>
                              <Col className="form-field" md="5">
                                {item.fieldName}
                              </Col>
                              <Col className="form-field" md="2">
                                {item.dataType}
                              </Col>
                              <Col className="form-field" md="2">
                                {item.isRequired === true ? "Yes" : "No"}
                              </Col>
                              <Col className="form-field" md="2">
                                {item.isPrimaryKey === true ? "Yes" : "No"}
                              </Col>
                              <Col className="form-label" md="1">
                                <div
                                  className="closeBtn"
                                  onClick={this.deleteAsscKeyFieldName.bind(this, item.fieldName)}
                                  aria-label="Close"
                                >
                                  <TiDeleteOutline />
                                </div>
                              </Col>
                            </Row>
                          );
                        })}
                    </>
                  ) : (
                    <></>
                  )}
                </Col>
              </Row>

              <Row>
                <Button variant="primary" className="mt-3" onClick={this.createMasterFile}>
                  <FcPlus /> Save File
                </Button>
              </Row>
            </Form>
          </Modal.Body>
        </Modal>
      </div>
    );
  }
}

export default CreateProjectSuperAdmin;
